const modalityOptions = [
    { value: "CR", label: "CR" },
    { value: "CT", label: "CT" },
    { value: "DX", label: "DX" },
    { value: "ECG", label: "ECG" },
    { value: "EPS", label: "EPS" },
    { value: "ES", label: "ES" },
    { value: "IO", label: "IO" },
    { value: "IVUS", label: "IVUS" },
    { value: "MG", label: "MG" },
    { value: "MR", label: "MR" },
    { value: "NM", label: "NM" },
    { value: "OT", label: "OT" },
    { value: "OP", label: "OP" },
    { value: "OPT", label: "OPT" },
    { value: "OCT", label: "OCT" },
    { value: "PT", label: "PT" },
    { value: "PX", label: "PX" },
    { value: "RF", label: "RF" },
    { value: "RG", label: "RG" },
    { value: "SC", label: "SC" },
    { value: "XA", label: "XA" },
    { value: "US", label: "US" },
    { value: "XC", label: "XC" },
    { value: "LIVE", label: "LIVE" }
  ]

  const STUDY_STATUS_OPTIONS = [
    { value: "Reported", label: "Reported" },
    { value: "Examined", label: "Examined" },
    { value: "Draft", label: "Draft" },
    { value: "Verified", label: "Verified" }
  ]
    //   Unread: "Examined",
    //   Preliminary: "Draft",
    //   Ready: "Verified",
    //   Final: "Reported"
    // }

  export {modalityOptions, STUDY_STATUS_OPTIONS}